export default __webpack_public_path__ + "static/media/nft1.1f7ca841.jpeg";